import { useRef, useEffect } from "react";
function useFocusClassName(className) {
  const targetRef = useRef(null);
  return useEffect(() => {
    const target = targetRef.current;
    if (!target) return;
    const input = target.querySelector("input");
    if (!input) return;
    function handleClick(event) {
      target != null && target.contains(event.target) || (target == null || target.classList.remove(className), document.removeEventListener("mousedown", handleClick));
    }
    const handleFocus = () => {
      target.classList.add(className), document.removeEventListener("mousedown", handleClick), document.addEventListener("mousedown", handleClick);
    };
    return input.addEventListener("focus", handleFocus), () => {
      input.removeEventListener("focus", handleFocus), document.removeEventListener("mousedown", handleClick);
    };
  }, [className]), { targetRef };
}
export {
  useFocusClassName
};
//# sourceMappingURL=useFocusClassName.js.map
